// extracted by mini-css-extract-plugin
export var statItem = "_k2-1";
export var statsRow = "_k2-0";